module.exports = __webpack_public_path__ + "img/pc_header_bg.ad73ced.webp";